import { Box } from "@mui/material";
import {
  Aws,
  Azure,
  MsSqlServer,
  MySql,
  Oracle,
  PostgreSql,
} from "../../icons";
import styles from "./styles";

export const CloudIcon = ({ cloud }) => {
  const iconProps = { size: "30px" };
  const iconsMap = {
    oci: <Oracle {...iconProps} />,
    aws: <Aws {...iconProps} />,
    azure: <Azure {...iconProps} />,
  };
  return (
    iconsMap[cloud] || (
      <Box component="div" sx={styles.cloudIconTextBox}>
        {cloud}{" "}
      </Box>
    )
  );
};

export const EngineIcon = ({ engine }) => {
  const iconProps = { size: "30px" };
  const iconsMap = {
    mysql: <MySql {...iconProps} />,
    oracle: <Oracle {...iconProps} />,
    postgresql: <PostgreSql {...iconProps} />,
    sqlserver: <MsSqlServer {...iconProps} />,
  };
  return (
    iconsMap[engine] || (
      <Box component="div" sx={styles.cloudIconTextBox}>
        {engine}{" "}
      </Box>
    )
  );
};
